import useFetch from "../../api/useFetch";
import { ShowEmployee } from "../employees/ShowEmployee";

export const Profile = () => {
  return <ShowEmployee api={"users/own"} own={true} />;
};
